import "core-js/modules/es.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { VenueBlock } from './VenueBlock';
export var RecommendedVenues = function RecommendedVenues(_ref) {
  var recommendations = _ref.recommendations,
      venue = _ref.venue;
  return recommendations.length ? React.createElement("div", {
    className: "recommended-venues"
  }, React.createElement("span", {
    className: "recommended-venues__text"
  }, React.createElement(FormattedMessage, {
    id: "recommended.venues",
    defaultMessage: "If you like {venue}, you may also enjoy",
    values: {
      venue: venue
    }
  })), React.createElement("div", {
    className: "recommended-venues__items"
  }, recommendations.map(function (recommendation) {
    return React.createElement(VenueBlock, {
      key: recommendation.venue,
      url: "/studios/".concat(recommendation.alias),
      imageUrl: recommendation.imageUrl,
      venue: recommendation.venue
    });
  }))) : null;
};
RecommendedVenues.propTypes = {
  recommendations: PropTypes.arrayOf(PropTypes.shape({
    alias: PropTypes.string,
    imageUrl: PropTypes.string,
    venue: PropTypes.string
  })),
  venue: PropTypes.string
};